import {z} from 'zod';

import {XentryPositionTypeSchema} from '@dms/api/workshop';

export const XentryInformationFormSchema = z
  .object({
    damageCode: z.string().max(9).nullish(),
    xentryPositionType: XentryPositionTypeSchema.nullish(),
    isGrounded: z.boolean().nullish(),
    groundingReason: z.string().nullish(),
  })
  .refine(
    (data) =>
      data.isGrounded !== true || (data.groundingReason != null && data.groundingReason !== ''),
    {message: 'Grounding reason is required when vehicle is grounded', path: ['groundingReason']}
  );

export type XentryInformationFormType = z.infer<typeof XentryInformationFormSchema>;
